import { useAtom } from 'jotai'
import { AuthProvider } from 'lib/models'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom, resetAtom } = createAtom<AuthProvider>(AuthProvider.Email, MMKVKey.AuthProvider)

export const useAuthProviderAtom = () => useAtom(atom)
export const useResetAuthProviderAtom = () => useAtom(resetAtom)
